/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024/04/05
 **/

import { useEffect } from "react";
import { usePersistActions, usePersistStore } from "@/frameworks/core/persistence";

export default function usePhoneFavorite() {
	const favorites = usePersistStore((state) => state.favorites);
	const dispatch = usePersistActions();

	const is_favorite = (userID: string) => dispatch.favorites.is_favorite(userID);
	const add_favorite = async (userID: string) => await dispatch.favorites.add(userID);
	const changeOrder_favorite = async (favoriteId: string, orderNumber: number) =>
		await dispatch.favorites.changeOrder(favoriteId, orderNumber);
	const delete_favorite = async (userID: string) => await dispatch.favorites.delete(userID);

	useEffect(() => {
		dispatch.favorites.initialize();
	}, []);

	return {
		list: favorites,
		has: is_favorite,
		add: add_favorite,
		changeOrder: changeOrder_favorite,
		delete: delete_favorite
	};
}
